import { Box } from "@mui/material";
import Header from "../../../components/Header";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  addProduct,
  getProductsError,
  getProductsStatus,
  getProductsisLoading,
  getProductsSuccess,
} from "../../../features/productSlice";
import {
  selectAllCategories,
  fetchCategories,
} from "../../../features/categorySlice";
import { useNavigate } from "react-router-dom";
import { getTypes, selectAllTypes } from "../../../features/typeSlice";
import {
  getTypeVariations,
  selectAllTypeVariations,
} from "../../../features/typeVariationSlice";
import {
 getAllergys,
 selectAllAllergys
} from "../../../features/allergySlice";
import { useRestaurant } from "../../../hooks/RestaurantContext";
import ProductForm from "./productForm";
import BackButton from "../../../components/backButton";
import { getImageFormFields } from "../../../global/functions/imageHelper";
import { useTranslation } from "react-i18next";

const AddProduct = ({ onClose, isDialog = false }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { restaurantId } = useRestaurant();
  const [previewImage, setPreviewImage] = useState(null);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const status = useSelector(getProductsStatus);
  const error = useSelector(getProductsError);
  const loading = useSelector(getProductsisLoading);
  const success = useSelector(getProductsSuccess);
  const categories = useSelector(selectAllCategories);
  const typesWithIngrediants = useSelector(selectAllTypes);
  const typeVariation = useSelector(selectAllTypeVariations);
  const allergies = useSelector(selectAllAllergys);

  const initialValues = {
    name: "",
    description: "",
    image: "",
    // category: "",
    categories: [],
    allergies: [],
    type: [],
    variations: [],
    typeVariation: "",
    price: 0,
    formulePrice: 0,
    choice: "seul",
    outOfStock: false,
    visible: true,
    discountValue: null,
    discountStartDate: null,
    discountEndDate: null,
    tva: 0,
  };

  const handleFormSubmit = (values) => {
    if (categories.length === 0) {
      toast.error(
        "Vous devez d'abord créer une catégorie avant d'ajouter un produit."
      );
      return;
    }
    const selectedTypeIds = selectedTypes.map((type) => type._id);
    const imageFields = getImageFormFields(previewImage);
    if (!imageFields.image && !imageFields.mediaId) {
      toast.error("Veuillez sélectionner ou télécharger une image");
      return;
    }
    const requestBody = {
      name: values.name,
      description: values.description,
      ...imageFields,
      price: values.price,
      formulePrice: values.formulePrice,
      choice: values.choice,
      outOfStock: values.outOfStock,
      visible: values.visible,
      // category: values.category,
      categories: values.categories,
      allergies: values.allergies,
      type: selectedTypeIds,
      typeVariation: values.typeVariation,
      variations: values.variations.map((v) => ({
        _id: v.variation,
        price: v.price,
      })),
      discountValue: values.discountValue,
      discountStartDate: values.discountStartDate,
      discountEndDate: values.discountEndDate,
      tva: values.tva,
    };
    dispatch(
      addProduct({
        body: requestBody,
        restaurantId: restaurantId,
      })
    )
      .unwrap()
      .then((createdProduct) => {
        toast.success("Produit créé");
        if (isDialog) {
          onClose?.({ product: createdProduct }); 
        } else {
          navigate("/products");
        }
      })
      .catch((err) => {
        toast.error(err?.message || "Erreur");
      });
  };

  const handleTypeSelect = (event) => {
    const selectedTypeIds = event.target.value;
    setSelectedTypes((prevTypes) => {
      return typesWithIngrediants.filter((type) =>
        selectedTypeIds.includes(type._id)
      );
    });
  };

  useEffect(() => {
    dispatch(getTypeVariations(restaurantId));
    dispatch(getTypes(restaurantId));
    dispatch(fetchCategories(restaurantId));
    dispatch(getAllergys());
  }, [dispatch, restaurantId]);

  useEffect(() => {
    if (status === "addSuccess") {
      toast.success(success);
      if (!isDialog) {
        navigate("/products");
      }
    } else if (status === "addError") {
      toast.error(error);
    }
  }, [
    status,
    error,
    dispatch,
    navigate,
    success,
    isDialog,
    onClose,
    restaurantId,
  ]);

  return (
    <Box m="20px" className="main-application">
      <BackButton />
      <Header title={t("headers.addProduct")} subtitle={t("headers.addProductSub")} />
      <ProductForm
        buttonText={t("common.submit")}
        handleFormSubmit={handleFormSubmit}
        initialValues={initialValues}
        categories={categories}
        previewImage={previewImage}
        setPreviewImage={setPreviewImage}
        selectedTypes={selectedTypes}
        handleTypeSelect={handleTypeSelect}
        typesWithIngrediants={typesWithIngrediants}
        typeVariation={typeVariation}
        setSelectedTypes={setSelectedTypes}
        loading={loading}
        isDialog={isDialog}
        allergies={allergies}
      />
    </Box>
  );
};

export default AddProduct;
